// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__1LJeu","upload-btn":"App_upload-btn__2zG_I","submit-file":"App_submit-file__2qkBd","file-tree-with-modal":"App_file-tree-with-modal__12TkB"};